// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from file-code-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function FileCodeFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M11 0v3.5a.5.5 0 0 0 .41.492L11.5 4H15v11.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5H11ZM6.53 5.47a.75.75 0 0 0-1.06 0l-2 2-.073.084a.75.75 0 0 0 .073.976l2 2 .084.073a.75.75 0 0 0 .976-.073l.073-.084a.75.75 0 0 0-.073-.976L5.061 8l1.47-1.47.072-.084a.75.75 0 0 0-.073-.976Zm3.916-.073a.75.75 0 0 0-1.049 1.05l.073.083L10.939 8l-1.47 1.47-.08.094a.75.75 0 0 0 .008.882l.073.084.094.08a.75.75 0 0 0 .882-.007l.084-.073 2-2 .08-.094a.75.75 0 0 0-.007-.882l-.073-.084-2-2ZM12.333 0a.5.5 0 0 1 .352.144l2.167 2.143a.5.5 0 0 1 .148.356V3h-2.75a.25.25 0 0 1-.25-.25V0h.333Z"
      />
    </svg>
  );
}
